"use client";

import React from "react";
import { ArrowRight, ChevronDown, Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * WebsiteForCoachesAndConsultants — Section 1: Hero
 * Drop-in für: src/pages/WebsiteForCoachesAndConsultants/sections/KhatVongDanDau.tsx
 */

export default function KhatVongDanDau() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="hero" className="relative bg-background py-20 md:py-32 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: "linear-gradient(to right, var(--color-foreground) 1px, transparent 1px), linear-gradient(to bottom, var(--color-foreground) 1px, transparent 1px)",
      backgroundSize: "4rem 4rem"
    }} />
      <div className="absolute top-0 left-0 w-96 h-96 bg-primary/10 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-[150px] pointer-events-none" />

      <div ref={ref} className={`relative max-w-5xl mx-auto px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary text-sm font-medium mb-8">
          <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
          Für Coaches, Therapeuten &amp; Berater
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight text-foreground mb-8 leading-[1.05]">
          Ihre Expertise verdient
          <br />
          <span className="text-primary">eine professionelle Bühne.</span>
        </h1>

        <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl mx-auto leading-relaxed">
          Zeigen Sie, wer Sie sind und was Sie bieten. Ihre Coach-Website —
          persönlich, vertrauenswürdig, in Minuten erstellt. Ab CHF 24/Monat.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="https://dashboard.pagemaker24.ch/sign-up" className="group inline-flex items-center justify-center gap-2 bg-primary text-white px-8 py-4 rounded-full text-base font-medium shadow-lg shadow-primary/20 hover:shadow-xl hover:shadow-primary/30 hover:scale-105 transition-all">
            Coach-Website erstellen
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>
          <a href="#beispiel-mockup" className="inline-flex items-center justify-center gap-2 text-muted-foreground hover:text-primary px-6 py-4 text-base font-medium transition-colors">
            Beispiel ansehen
            <ChevronDown className="w-4 h-4" />
          </a>
        </div>

        <div className="mt-10 flex items-center justify-center gap-6 text-xs text-muted-foreground flex-wrap">
          <span className="flex items-center gap-1.5">
            <Check className="w-4 h-4 text-green-500" strokeWidth={2.5} />
            3 Tage gratis testen
          </span>
          <span className="flex items-center gap-1.5">
            <Check className="w-4 h-4 text-green-500" strokeWidth={2.5} />
            Keine Kreditkarte nötig
          </span>
          <span className="flex items-center gap-1.5">
            <Check className="w-4 h-4 text-green-500" strokeWidth={2.5} />
            Hosting + Domain inklusive
          </span>
        </div>
      </div>
    </section>;
}